import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { useQuery } from '../../../../hooks/useQuery'

import DocumentIcon from '../../../../components/Icons/DocumentIcon'
import DocumentTypes from '../../../../components/Documents/DocumentTypes'
import DocumentTypeForm from '../../../../components/Documents/DocumentTypeForm'
import MaynLayout from '../../../../components/Core/MainLayout'
import PageLayout from '../../../../components/Core/PageLayout'
import TitleBlock from '../../../../components/Core/TitleBlock'
import Dashboard from '../../../../components/Core/Dashboard'

const DocumentTypesScreen = () => {
  const { t } = useTranslation()
  const { tab: activeTab } = useQuery(['tab:document_types'])
  const history = useHistory()

  const handleNewType = () => {
    history.push({search: `?tab=document_type`})
  }

  return (
    <MaynLayout>
      <Dashboard>
        <TitleBlock
          title={t('Document types')}
          TitleButtonNew={activeTab === 'document_types' ? t('New type') : null}
          handleButtonNew={handleNewType}
        >
          <DocumentIcon color="rgba(226, 235, 244, 0.85)" width={44} height={44} />
        </TitleBlock>
        <PageLayout>
          {
            (tab => {
              switch (tab) {
                case 'document_types':
                  return <DocumentTypes />
                case 'document_type':
                  return <DocumentTypeForm />
                default:
                  return null
              }
            })(activeTab)
          }
        </PageLayout>
      </Dashboard>
    </MaynLayout>
  )
}

export default DocumentTypesScreen

